import { Icon } from '@mui/material';
import PropTypes from 'prop-types';
import MDBox from 'shared/components/MDBox';
import MDInput from 'shared/components/MDInput';
import MDPagination from 'shared/components/MDPagination';
import MDTypography from 'shared/components/MDTypography';

function ListPagination({ page, limit, total, onPageChange, variant, color }) {
  const paginationCount = Math.ceil(total / limit);

  const renderPagination = () => {
    const pagMap = [];
    for (let i = 0; i < paginationCount; i++) {
      pagMap.push(
        <MDPagination
          item
          key={i}
          onClick={() => onPageChange(i + 1)}
          active={page === i + 1}
        >
          {i + 1}
        </MDPagination>
      );
    }
    return pagMap;
  };

  if (total === 0) return null;

  return (
    <MDBox
      display='flex'
      flexDirection={{ xs: 'column', sm: 'row' }}
      justifyContent='space-between'
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      p={3}
    >
      <MDTypography variant='button' color='secondary' fontWeight='regular'>
        Mostrando {(page - 1) * limit + 1} à{' '}
        {Math.min(page * limit, total)} de {total}{' '}
        {total === 1 ? 'item' : 'itens'}
      </MDTypography>
      {paginationCount > 1 && (
        <MDPagination variant={variant} color={color}>
          {page > 1 && (
            <MDPagination
              item
              onClick={() => onPageChange(page - 1)}
            >
              <Icon sx={{ fontWeight: 'bold' }}>chevron_left</Icon>
            </MDPagination>
          )}
          {renderPagination().length > 6 ? (
            <MDBox width='5rem' mx={1}>
              <MDInput
                inputProps={{
                  type: 'number',
                  min: 1,
                  max: paginationCount,
                }}
                value={page}
                onChange={({ target }) => {
                  const val = Number(target.value);
                  if (val >= 1 && val <= paginationCount) {
                    onPageChange(val);
                  }
                }}
              />
            </MDBox>
          ) : (
            renderPagination()
          )}
          {page < paginationCount && (
            <MDPagination
              item
              onClick={() => onPageChange(page + 1)}
            >
              <Icon sx={{ fontWeight: 'bold' }}>chevron_right</Icon>
            </MDPagination>
          )}
        </MDPagination>
      )}
    </MDBox>
  );
}

ListPagination.defaultProps = {
  variant: 'gradient',
  color: 'info',
};

ListPagination.propTypes = {
  page: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['gradient', 'contained']),
  color: PropTypes.oneOf([
    'white',
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'error',
    'light',
    'dark',
  ]),
};

export default ListPagination;
